import React, { Component } from "react";
import PropTypes from "prop-types";
import * as ReactSpark from "react-spark";

class AlertMessage extends Component {
  render() {
    const { isDisplayed, type, inline, children, handleAlertDismissed } = this.props;
    const { dismissible, idString, analyticsString } = this.props;
    const className = inline ? "inline" : "";

    if (!isDisplayed) {
      return null;
    }

    return (
      <ReactSpark.Alert
        type={type}
        className={className}
        dismissible={dismissible}
        idString={idString}
        analyticsString={analyticsString}
        handleAlertDismissed={handleAlertDismissed}
      >
        {children}
      </ReactSpark.Alert>
    );
  }
}

AlertMessage.defaultProps = {
  dismissible: false,
  idString: "",
  analyticsString: "",
  handleAlertDismissed: () => {}
};

AlertMessage.propTypes = {
  type: PropTypes.string.isRequired,
  isDisplayed: PropTypes.bool.isRequired,
  dismissible: PropTypes.bool,
  idString: PropTypes.string,
  analyticsString: PropTypes.string,
  handleAlertDismissed: PropTypes.func,
};

export default AlertMessage;
